import React, { Component } from 'react';
import { connect } from 'react-redux';
import motorVehicles from '../../modules/data/motor-vehicles';
import mobileHomes from '../../modules/data/mobile-homes';
import vessels from '../../modules/data/vessels';
import heavyTrucks from '../../modules/data/heavy-trucks';
import lease from '../../modules/data/lease';
import buses from '../../modules/data/buses';
import { resetMobileHome } from '../../redux/modules/mobilehome';
import Dropdown from '../../components/Dropdown';
import getPipeValue from '../../modules/getPipeValue';
import { VEHICLES, PIPE } from '../../modules/constants';
import {
  setSelectedVehicle,
  setToMotorVehicleSelection,
  setToMobileHomeSelection,
  setToVesselSelection,
  setToHeavyTruckSelection,
  setToLeaseSelection,
  setToBusSelection,
  setRegistrationConsole,
  resetAllExceptMonth,
} from '../../redux/modules/registration';

class VehicleSelectRow extends Component {
  constructor(props) {
    super(props);
    this.setVehicleValue = this.setVehicleValue.bind(this);
  }

  setVehicleValue(type, selection) {
    this.props.resetMobileHome();
    this.props.resetAllExceptMonth();
    const description = getPipeValue(selection, PIPE.DESCRIPTION);
    this.props.setRegistrationConsole(description);

    if (type === VEHICLES.MOTOR_VEHICLE) {
      this.props.setToMotorVehicleSelection(selection);
    }

    if (type === VEHICLES.MOBILE_HOMES) {
      this.props.setToMobileHomeSelection(selection);
    }

    if (type === VEHICLES.HEAVY_TRUCKS) {
      this.props.setToHeavyTruckSelection(selection);
    }

    if (type === VEHICLES.VESSELS) {
      this.props.setToVesselSelection(selection);
    }

    if (type === VEHICLES.LEASE_HIRE_TRAILER) {
      this.props.setToLeaseSelection(selection);
    }

    if (type === VEHICLES.BUSES_TRAILER) {
      this.props.setToBusSelection(selection);
    }
  }

  render() {
    const { vehicleValue, vehicleType } = this.props;

    return (
      <div id="Box">
        <div className="MenuHolder">

          <Dropdown
            className={`Dropdown VehicleDropdown${vehicleType === VEHICLES.MOTOR_VEHICLE ? ' VehicleDropdown--active' : ''}`}
            initial={['Motor Vehicles', '0']}
            id="DynolistVehicle"
            tooltip="Autos, Trucks, and Others"
            options={motorVehicles}
            onChange={event => this.setVehicleValue(VEHICLES.MOTOR_VEHICLE, event.target.value)}
            selectedValue={vehicleValue}
          />

          <Dropdown
            className={`Dropdown VehicleDropdown${vehicleType === VEHICLES.MOBILE_HOMES ? ' VehicleDropdown--active' : ''}`}
            initial={['Mobile Homes', '0']}
            id="DynolistHS"
            tooltip="Mobile Homes"
            options={mobileHomes}
            onChange={event => this.setVehicleValue(VEHICLES.MOBILE_HOMES, event.target.value)}
            selectedValue={vehicleValue}
          />

          <Dropdown
            className={`Dropdown VehicleDropdown${vehicleType === VEHICLES.VESSELS ? ' VehicleDropdown--active' : ''}`}
            initial={['Vessels', '0']}
            id="DynolistVS"
            tooltip="Vessels"
            options={vessels}
            onChange={event => this.setVehicleValue(VEHICLES.VESSELS, event.target.value)}
            selectedValue={vehicleValue}
          />

          <Dropdown
            className={`Dropdown VehicleDropdown${vehicleType === VEHICLES.HEAVY_TRUCKS ? ' VehicleDropdown--active' : ''}`}
            initial={['Heavy Trucks', '0']}
            id="DynolistHT"
            tooltip="Heavy Trucks"
            options={heavyTrucks}
            onChange={event => this.setVehicleValue(VEHICLES.HEAVY_TRUCKS, event.target.value)}
            selectedValue={vehicleValue}
          />

          <Dropdown
            className={`Dropdown VehicleDropdown${vehicleType === VEHICLES.LEASE_HIRE_TRAILER ? ' VehicleDropdown--active' : ''}`}
            initial={['Lease/Hire Auto/Trailer', '0']}
            id="DynolistLease"
            tooltip="09 Lease / For Hire Vehicles"
            options={lease}
            onChange={event => this.setVehicleValue(VEHICLES.LEASE_HIRE_TRAILER, event.target.value)}
            selectedValue={vehicleValue}
          />

          <Dropdown
            className={`Dropdown VehicleDropdown${vehicleType === VEHICLES.BUSES_TRAILER ? ' VehicleDropdown--active' : ''}`}
            initial={['Trailer > 500 (53) & Buses', '0']}
            id="DynolistBus"
            tooltip="Trailer &gt; 500 (53) &amp; Buses"
            options={buses}
            onChange={event => this.setVehicleValue(VEHICLES.BUSES_TRAILER, event.target.value)}
            selectedValue={vehicleValue}
          />

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    vehicleValue: state.registration.selectedVehicleValue,
    vehicleType: state.registration.selectedVehicleType,
    monthsFromNow: state.registration.monthsFromNow,
    svcFees: state.registration.svcFees,
  };
};

export default connect(mapStateToProps, {
  setSelectedVehicle,
  setRegistrationConsole,
  setToMotorVehicleSelection,
  setToMobileHomeSelection,
  setToVesselSelection,
  setToHeavyTruckSelection,
  setToLeaseSelection,
  setToBusSelection,
  resetMobileHome,
  resetAllExceptMonth,
})(VehicleSelectRow);
